import _ from 'lodash'
import scrollIntoView from '../../core/utils/KScrollIntoView'
// import KFocused from '../../core/mixins/focused/KFocused'
import Button from '../button'
import ScrollBar from '../scrollbar'
import SelectSearch from './SelectSearch'

export default {
  name: 'KSelectDropdown',
  provide() {
    const injectedData = {
      selectedValue: this.selectedValue,
      keepHovered: this.keepHovered,
    }
    Object.defineProperty(injectedData, 'selectedValue', {
      enumerable: true,
      get: () => this.selectedValue,
    })

    Object.defineProperty(injectedData, 'keepHovered', {
      enumerable: true,
      get: () => this.keepHovered,
    })

    Object.defineProperty(injectedData, 'hoveredOption', {
      enumerable: true,
      get: () => this.hoveredOption,
    })

    Object.defineProperty(injectedData, 'multiple', {
      enumerable: true,
      get: () => this.multiple,
    })

    return {
      onOptionClick: this.handleOptionClick,
      onOptionHover: this.handleOptionHover,
      onOptionUnHover: this.handleOptionUnHover,
      onOptionSelect: this.handleOptionSelect,
      addOption: this.addOption,
      removeOption: this.removeOption,
      injectedData,
    }
  },
  // mixins: [KFocused],
  props: {
    selectedValue: {
      validator: () => true,
      default() {
        return null
      },
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    supportSelectAll: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    // showSearch为true的情况才会生效
    autoFocus: {
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      type: String,
    },
    searchIcon: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
    showClose: {
      type: Boolean,
    },
    keepHovered: {
      type: Boolean,
    },
  },
  data() {
    return {
      hoveredOption: null,
      options: [],
      availableOptions: [],
    }
  },
  computed: {
    // options() {
    //   const groups = _.filter(this.$refs.optionWrapper.$children, (child) => child.$options.name === 'KOptgroup')
    //   if (groups && groups.length) {
    //     return _.reduce(
    //       groups,
    //       (result, group) => {
    //         return _.concat(result, _.filter(group.$children, (child) => child.$options.name === 'KOption'))
    //       },
    //       [],
    //     )
    //   }
    //   return _.filter(this.$refs.optionWrapper.$children, (child) => child.$options.name === 'KOption')
    // },
    // availableOptions() {
    //   console.log('availableOptionsavailableOptionsavailableOptions: ', this.options)
    //   return _.filter(this.options, (option) => !option.disabled)
    // },
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          // this.$nextTick(() => {
          //   this.$refs.scrollbar && this.$refs.scrollbar.update()
          // })

          // search input focus
          if (this.showSearch && this.$refs.search && this.autoFocus) {
            this.$nextTick(() => {
              this.$refs.search.focus()
            })
          }

          // scroll into view
          const selectedOption = _.find(this.options, ['selected', true])
          if (selectedOption) {
            scrollIntoView(selectedOption.$el, {
              boundary: this.$refs.optionWrapper.wrap,
              behavior: 'instant',
            })

            // this.$nextTick(() => {
            //   this.hoveredOption = selectedOption
            // })
          }
        }
      },
    },
    // hoveredOption() {
    // if (this.visible && value) {
    //   scrollIntoView(value.$el, {
    //     scrollMode: 'if-needed',
    //     duration: 0.1,
    //     block: 'nearest',
    //     boundary: this.$refs.optionWrapper.wrap,
    //   })
    // }
    // },
    options: {
      immediate: true,
      handler(options) {
        this.$emit('option-update', options)
        this.availableOptions = _.filter(this.options, (option) => !option.disabled)
        //   const { options, hoveredOption } = this
        //   if (hoveredOption) {
        //     const has = _.find(options, hoveredOption)
        //     if (!has) {
        //       this.hoveredOption = null
        //     }
        //   }
      },
    },
  },
  methods: {
    renderSearchPanel() {
      if (!this.showSearch) {
        return
      }

      return (
        <SelectSearch
          ref="search"
          placeholder={this.searchPlaceholder}
          icon={this.searchIcon}
          onSearch={(token) => {
            this.$emit('search-update', token)
          }}
          onKeydown={(keyCode) => {
            this.$emit('search-keydown', keyCode)
          }}
        >
          {this.$slots.searchExtra}
          <template slot="footer">
            {this.$slots.searchFooter}
          </template>
        </SelectSearch>
      )
    },
    renderSelectAllPanel() {
      if (!this.supportSelectAll) {
        return
      }

      return (
        <div class="km-select__select-all-panel">
          <Button
            type="primary"
            plain
            fullWidth
            size="small"
            onClick={this.handleSelectAll}
          >全选</Button>
          <Button
            type="primary"
            plain
            fullWidth
            size="small"
            onClick={this.handleUnselectAll}
          >全不选</Button>
        </div>
      )
    },
    handleSelectAll() {
      this.$emit('select-all')
    },
    handleUnselectAll() {
      this.$emit('unselect-all')
    },
    handleOptionSelect(option) {
      this.$nextTick(() => {
        this.$emit('option-select', option)
      })
    },
    handleOptionClick(option) {
      this.$nextTick(() => {
        this.$emit('option-click', option)
      })
    },
    handleOptionHover(option) {
      this.hoveredOption = option
    },
    handleOptionUnHover() {
      this.hoveredOption = null
    },
    scrollHoverOptionIntoView() {
      if (this.visible && this.hoveredOption) {
        scrollIntoView(this.hoveredOption.$el, {
          scrollMode: 'if-needed',
          duration: 0.1,
          block: 'nearest',
          boundary: this.$refs.optionWrapper.wrap,
        })
      }
    },
    hoverNextOption() {
      let hoveredIndex = 0
      if (this.hoveredOption) {
        hoveredIndex = _.findIndex(this.availableOptions, (option) => option === this.hoveredOption)
        if (hoveredIndex !== -1 && hoveredIndex + 1 !== this.availableOptions.length) {
          hoveredIndex = hoveredIndex + 1
        } else {
          hoveredIndex = 0
        }
      }
      this.hoveredOption = this.availableOptions[hoveredIndex]
      this.scrollHoverOptionIntoView()
    },
    hoverPrevOption() {
      let hoveredIndex = this.availableOptions.length - 1
      if (this.hoveredOption) {
        hoveredIndex = _.findIndex(this.availableOptions, (option) => option === this.hoveredOption)
        if (hoveredIndex !== -1 && hoveredIndex !== 0) {
          hoveredIndex = hoveredIndex - 1
        } else {
          hoveredIndex = this.availableOptions.length - 1
        }
      }
      this.hoveredOption = this.availableOptions[hoveredIndex]
      this.scrollHoverOptionIntoView()
    },
    // api
    selectOption() {
      if (this.hoveredOption) {
        this.$emit('option-click', this.hoveredOption)
      }
    },
    getOptions() {
      const $wrapper = this.$refs.optionWrapper
      const result = []
      if (!$wrapper) {
        return result
      }
      _.forEach($wrapper.$children, child => {
        const childName = child._isVue ? child.$options.name || child.$options._componentTag : child.name
        if (childName === 'KOption') {
          result.push(child)
        } else if (childName === 'KOptgroup') {
          _.forEach(child.$children, child => {
            const childName = child._isVue ? child.$options.name || child.$options._componentTag : child.name
            if (childName === 'KOption') {
              result.push(child)
            }
          })
        }
      })

      return result
    },
    addOption(option) {
      // addOption 可能使得 options 的顺序与实际出现偏差
      // this.options.push(option)
      // console.log('this.options: ', getAllDescendantComponentsByName(this.$refs.optionWrapper, 'KOption'))
      this.options = this.getOptions()
    },
    removeOption(option) {
      const optionIndex = this.options.indexOf(option)
      if (optionIndex !== -1) {
        this.options.splice(optionIndex, 1)
      }
    },
    reset() {
      if (this.showSearch) {
        this.$refs.search.clear()
      }
    },
  },
  mounted() {
  },
  render() {
    const css = {
      'km-select__dropdown--multiple': this.multiple,
    }

    const selectAllPanel = this.renderSelectAllPanel()
    const searchPanel = this.renderSearchPanel()

    return (
      <div class="km-select__dropdown" {...{ class: css }}>
        {this.$slots.header}
        {selectAllPanel}
        {searchPanel}
        <ScrollBar
          ref="optionWrapper"
          loading={this.loading}
          overScrollContain
          onScrollBottom={() => {
            this.$emit('load-more')
          }}
        >
          <div class="km-select__options">
            {this.$slots.default}
          </div>
          {this.loading ? this.$slots.loadMore : null}
        </ScrollBar>
        {
          this.$slots.footer
            ? <div class="km-select__dropdown-footer">
              {this.$slots.footer}
            </div>
            : null
        }
        {
          this.showClose
            ? (
              <div class="km-select__dropdown-close">
                <Button
                  fullWidth={true}
                  type="primary"
                  plainPlus={true}
                  onClick={() => {
                    this.$emit('select-close')
                  }}
                >关闭</Button>
              </div>
            )
            : null
        }
      </div>
    )
  },
}
